import "../src/assets/styles/App.scss";
import { Routes, Route } from "react-router-dom";

import { OfferBar, NavBar, Footer } from "./components";
import { useState, useEffect } from "react";
import {
  Main,
  FAQ,
  ContactUs,
  Refund,
  Terms,
  Product,
  Cart,
  TransSucess,
  Collections,
  About,
  ProductsFiltered,
} from "./pages";
import productInfo from "./assets/data/productInfo";
import {
  siteInfo,
  faq,
  refundPolicy,
  termsOfService,
  about,
  contact,
  transactionSuccess,
  collections,
} from "./assets/data/siteData";

function App() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [cart, setCart] = useState([]);

  //Website Behavior Collection
  const pageReset = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product.id);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  //Main Page Collection
  const featuredCollectionCat = "Immune System";

  const featuredCollection = productInfo.filter((products) => {
    return products.collection === featuredCollectionCat;
  });

  const productMain = featuredCollection.slice(0, 4);

  //Search Products Information
  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const searchProducts = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    const filteredProducts = productInfo.filter((product) =>
      product.name.toLowerCase().includes(lowerCaseSearchTerm)
    );

    setFilteredProducts(filteredProducts);
  };

  //Update Shopping Cart
  const addToCart = (e) => {
    const { id, name, salePrice, media, quantity } = e;
    const image = media[0];
    const item = { id, name, salePrice, image, quantity };

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    setCart((prevCart) => {
      const isItemAlreadyInCart = prevCart.some((p) => p.id === item.id);
      if (isItemAlreadyInCart) {
        return prevCart.map((p) => {
          if (p.id === item.id) {
            return { ...p, quantity: p.quantity + item.quantity };
          }
          return p;
        });
      }
      return [...prevCart, item];
    });
  };

  const incrementQuantity = (e) => {
    setCart((prevCart) =>
      prevCart.map((product) => {
        if (product.id === e.id) {
          return { ...product, quantity: product.quantity + 1 };
        }
        return product;
      })
    );
  };

  const decrementQuantity = (e) => {
    setCart((prevCart) =>
      prevCart.map((product) => {
        if (product.id === e.id) {
          if (product.quantity > 1) {
            return { ...product, quantity: product.quantity - 1 };
          }
          return { ...product, quantity: 1 };
        }
        return product;
      })
    );
  };

  const removeItem = (e) => {
    setCart((prevCart) => prevCart.filter((product) => product.id !== e.id));
  };

  useEffect(() => {
    const storedCart = localStorage.getItem("cart");
    if (!storedCart) {
      setCart([]);
      return;
    }
    try {
      const parsedCart = JSON.parse(storedCart);
      setCart(Array.isArray(parsedCart) ? parsedCart : []);
    } catch (error) {
      setCart([]);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  return (
    <div className="App">
      <OfferBar />
      <NavBar
        searchProducts={searchProducts}
        handleInputChange={handleInputChange}
        searchTerm={searchTerm}
        filteredProducts={filteredProducts}
        collections={collections}
      />
      <Routes>
        <Route
          path="/"
          element={
            <Main
              featuredCollectionCat={featuredCollectionCat}
              productInfo={productMain}
              handleProductClick={handleProductClick}
              addToCart={addToCart}
              pageReset={pageReset}
            />
          }
        />
        <Route
          path="/product/:productId"
          element={
            <Product
              productInfo={productInfo}
              selectedProduct={selectedProduct}
              addToCart={addToCart}
            />
          }
        />
        <Route path="/faq" element={<FAQ faq={faq} />} />
        <Route path="/contact-us" element={<ContactUs contactUs={contact} />} />
        <Route path="/refund" element={<Refund refund={refundPolicy} />} />
        <Route path="/terms" element={<Terms terms={termsOfService} />} />
        <Route
          path="/cart"
          element={
            <Cart
              cart={cart}
              increment={incrementQuantity}
              decrement={decrementQuantity}
              removeItem={removeItem}
            />
          }
        />
        <Route
          // path="/transaction-success/:approved"
          path="/transaction-success"
          element={<TransSucess transactionSuccess={transactionSuccess} />}
        />
        <Route
          path={`/featured-collection/:collection`}
          element={
            <Collections
              handleProductClick={handleProductClick}
              addToCart={addToCart}
              productInfo={productInfo}
            />
          }
        />
        <Route path="/about" element={<About about={about} />} />
        <Route
          path="/products-filtered"
          element={
            <ProductsFiltered
              filteredProducts={filteredProducts}
              handleProductClick={handleProductClick}
              addToCart={addToCart}
            />
          }
        />
      </Routes>
      <Footer handleProductClick={pageReset} siteInfo={siteInfo} />
    </div>
  );
}

export default App;
